import React, { useState, useEffect } from 'react'
import { Row, Form, Button, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { toast } from 'react-toastify';
import { useGetPublicsubjectQuery } from '../../slices/teachers/subjectApiSlice';
import { useCreateCourseMutation, usePublishCourseMutation, useUpdateLessonMutation, useDeleteLessonMutation, useGetCourseQuery, useCreateLessonMutation, useAddSectionMutation } from '../../slices/teachers/courseApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const TeacherNewLessons = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { id } = useParams();
    const [loading, setLoading] = useState(false); 
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [section, setSection] = useState('');
    const [selectedSection, setSelectedSection] = useState('');
    const [selectedsectionnumber, setSelectedsectionnumber] = useState('');
    const [sections, setSections] = useState(null);
    const [title, seTitle] = useState('');
    const [isvideo, setIsvideo] = useState(false); 
    const [videoFile, setVideoFile] = useState(null); 
    const [videolesson, setVideolesson] = useState(null); 
    const [lessons, setLessons] = useState(null); 
    const [lessonsBySection, setLessonsBySection] = useState([]);   

    const { data, error, isLoading, refetch } = useGetCourseQuery(id);

    const { teacherInfo } = useSelector((state) => state.authTeacher);

    const [createLesson, { isLoading: courseLoading, error: courseError }] = useCreateLessonMutation();

    const [deleteLesson, { isLoading: deleteLoading, error: deleteError }] = useDeleteLessonMutation();

    const [AddSection, { isLoading: sectionLoading, error: sectionError }] = useAddSectionMutation();

    const [UpdateLesson, { isLoading: updateLoading, error: updateError }] = useUpdateLessonMutation();

    const [PublishCourse, { isLoading: publishLoading, error: publishError }] = usePublishCourseMutation();

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
    }, [navigate, teacherInfo])

    useEffect(() => {
        const groupedLessons = data?.lessons.reduce((acc, lesson) => {
            if (!acc[lesson.sectionNumber]) {
                acc[lesson.sectionNumber] = [];
            }
            acc[lesson.sectionNumber].push(lesson);
            return acc;
        }, []);
        groupedLessons?.forEach(section => {
            section.sort((a, b) => a.lessonNumber - b.lessonNumber);
        });
        setLessonsBySection(groupedLessons);
    }, [data]);

    useEffect(() => {
        setName(data?.name);
        setDescription(data?.description);
        setLessons(data?.lessons);
        data?.sections.forEach(element => {
            setSections((prevSections) => [...(prevSections || []), element.sectionTitle]);
        });
    }, [data]);

    const goToCourse = () => {
        window.open(`${window.location.origin}/teacherwatchcourse/${id}`, '_blank')
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          if (file.type == 'video/mp4' ||  file.type == 'video/quicktime' || file.type == 'video/avi') { 
            setIsvideo(true); 
            setVideoFile(event.target.files[0]); 
          } else {  
            toast.error('Please upload a mp4 or quicktime or avi video file ');
          }
        } 
    };
      
    const addSectionHandler = async () => {
        setLoading(true);
        try {
            const res = await AddSection({ section, id }).unwrap();
            setSection('');
            setSections(null);
            toast.success('Section added successfully');
            setLoading(false);
            refetch();
        } catch (err) {
            toast.error(err?.data?.message || err.error.message);
            setLoading(false);
        }
    };

    const handleSectionChange = (event) => {
        setSelectedSection(event.target.value);
        const selectedSectionObj = data?.sections.find(sec => sec.sectionTitle === event.target.value);
        setSelectedsectionnumber(selectedSectionObj ? selectedSectionObj.sectionNumber : '');
    };

    const deleteHandler = async (e) => {
        var fd = new FormData();
        fd.append('mediaId', e.mediaId);
        fetch('/api/upload/deletelesson',
            {
              method: 'post',
              body: fd,
            })
            .then(response => response.json())
            .then(async data => {
              try {
                const res = await deleteLesson(e).unwrap();
                setSections(null);
                refetch();
                toast.success('Lesson deleted successfully');
                } catch (err) {
                    toast.error(err?.data?.message || err.error.message);
                }
            })
    };

    const moveLessonUp = async (lessonGoUp, lessonGoDown) => {
        setLoading(true);
        try {
            const res = await UpdateLesson({
                id1: lessonGoUp._id,        
                lessonNumber1: lessonGoDown.lessonNumber,
                id2: lessonGoDown._id,
                lessonNumber2: lessonGoUp.lessonNumber,
            }).unwrap();
            setSections(null);
            refetch();
            toast.success('Lesson moved up successfully');
            setLoading(false);
        } catch (err) {
            toast.error(err?.data?.message || err.error.message);
        }
    };

    const moveLessonDown = async (lessonGoDown, lessonGoUp, ) => {
        setLoading(true);
        try {
            const res = await UpdateLesson({
                id1: lessonGoDown._id,        
                lessonNumber1: lessonGoUp.lessonNumber,
                id2: lessonGoUp._id,
                lessonNumber2: lessonGoDown.lessonNumber,
            }).unwrap();
            setSections(null);
            refetch();
            toast.success('Lesson moved down successfully');
            setLoading(false);
        } catch (err) {
            toast.error(err?.data?.message || err.error.message);
        }
    };
    
    const pusblishHandle = async () => {
        setLoading(true);
        try {
            const res = await PublishCourse({ id }).unwrap();
            setSections(null);
            refetch();
            toast.success('Course published successfully');
            setLoading(false);
        } catch (err) {
            toast.error(err?.data?.message || err.error.message);
        }
    };
    
    const submitHandler = async (e) => {
        e.preventDefault()
        setLoading(true);
        if (isvideo) {
            var fd = new FormData();
            fd.append('upl', videoFile);
            fetch('/api/upload/uploadlessonvideo',
            {
              method: 'post',
              body: fd,
            })
            .then(response => response.json())
            .then(async data => {
              try {
                const res = await createLesson({
                    title,
                    id,
                    selectedSection,
                    selectedsectionnumber,
                    data
                }).unwrap();
                seTitle('');
                setSelectedSection('');
                setSections(null);
                refetch();
                toast.success('Lesson added successfully');
                setLoading(false);
            } catch (err) {
                toast.error(err?.data?.message || err.error.message);
            }
            })
            .catch(error => {
              toast.error('Error uploading video');
              setLoading(false);
            });
        } else {  
            toast.error('Please upload a mp4 or quicktime or avi video file');  
        }       
    };

    return (
    <div>
        <TeacherNavbar />
        <div className="main-content" id="panel">
        <TeacherHeader /><br /><br /><br /><br /><br />
            <div className="container-fluid mt--6">
                <div className="row">
                    <div className="col-xl-10 offset-xl-1 ">  
                        <div className="card-wrapper">
                            <div className="card ">
                                <div className=""><br /><br />
                                    <h3 className="mb-0 centerTitle  tittleColor4">
                                    <span className='tittleColor4' style={{textTransform: 'capitalize'}}>  
                                        {name} Lessons
                                    </span>
                                    </h3><br /><br />
                                </div>
                                
                                {loading ? ( 
                                        <Loader />
                                    ) : error ? (
                                        <Message variant='danger'>
                                            {error?.data?.message || error.error}
                                        </Message>
                                    ) : (  
                                    <>      
                                    <div className="row">
                                        <div className=' col-md-5 col-xl-5 sectionCol '>                     
                                            <Form onSubmit={addSectionHandler}>
                                                <h4 className="mb-0 centerTitle  tittleColor4">
                                                <small className='courseSteps'>( 1 )</small> 

                                                <span className='tittleColor31 courseSec2'>  
                                                    Add course Section
                                                </span>
                                                </h4>   
                                                <div className="form-group">
                                                        <div className="input-group input-group-merge input-group-alternative mb-3 courseForm1">
                                                            <div className="input-group-prepend moveInput">
                                                                <span className="input-group-text bg-gradient-primary"><i className="ni ni-tag navText"></i></span>
                                                            </div>
                                                            <input 
                                                                className="form-control emailForm " 
                                                                placeholder="Section name" 
                                                                type="text" 
                                                                value={section}
                                                                onChange={(e) => setSection(e.target.value)}   
                                                            />
                                                        </div>
                                                </div><br />
                                                <div className='mycard'>
                                                    <Button  type='submit' variant="primary rounded-pill bg-gradient-primary btn-md courseSec2 "> 
                                                        Add Section  
                                                    </Button>
                                                </div>
                                            </Form><br /><br /><br />
                                        </div>
                                        <div className=' sectionCol2 col-md-5  col-xl-5 '>                     
                                            <Form onSubmit={submitHandler}>
                                                <h4 className="mb-0 centerTitle  tittleColor4">
                                                <small className='courseSteps'>( 2 )</small>
                                                <span className='tittleColor4 courseSec2'> 
                                                    Add Lessons                                             
                                                    </span>
                                                </h4>   
                                                <div className="form-group">
                                                    {/* <h6 className="" placeholder="  Plan Name" type="text">Lesson Title:</h6>    */}
                                                    <div className="input-group input-group-merge input-group-alternative mb-3 courseForm1">
                                                        <div className="input-group-prepend moveInput">
                                                            <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                                                        </div>
                                                        <input 
                                                            className="form-control emailForm" 
                                                            placeholder="Lesson Title" 
                                                            type="text" 
                                                            value={title}
                                                            onChange={(e) => seTitle(e.target.value)}   
                                                        />
                                                    </div>
                                                </div><br />
                                                <div className="form-group">
                                                    <label for="exampleInputEmail12">Course Sections:</label>
                                                        <div className="input-group input-group-merge input-group-alternative mb-3 courseForm1"> 
                                                            <div className="input-group-prepend moveInput">
                                                                <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                                                            </div>                                                   
                                                            <select                                                                                                                         
                                                                id='exampleInputEmail12'
                                                                value={selectedSection} 
                                                                className="form-control form-control2" 
                                                                onChange={handleSectionChange}
                                                            >
                                                                <option value="" disabled> Choose a Section</option>
                                                                {sections?.map((sectionn, index) => (
                                                                    <option key={index} value={sectionn}>
                                                                        {sectionn}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                </div><br />
                                                <div className="form-group">
                                                    <label for="exampleInputEmail1">Upload a video for your lesson</label>
                                                    <div className="input-group input-group-merge input-group-alternative mb-3 courseForm1">
                                                        <div className="input-group-prepend moveInput">
                                                            <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                                                        </div>                                                
                                                            <input 
                                                            id='exampleInputEmail1'
                                                            type="file" 
                                                            className="form-control" 
                                                            onChange={handleFileChange} 
                                                            />
                                                    </div>
                                                </div><br />                                     
                                                <div className='mycard'>
                                                    <Button  type='submit' variant="info rounded-pill bg-gradient-info btn-md courseSec2"> 
                                                        Add Lesson  
                                                    </Button>
                                                </div>
                                            </Form> <br /><br /><br /><br />
                                        </div> 
                                    </div>
                                    <div className="row">                                                                                
                                        <div className='col-xl-10 goToCourse'>
                                            <div className='mycard'>
                                            <h4 className="   ">
                                            <span className='tittleColor4 centerTitleCourse'> 
                                            <small className='courseSteps'>( 3 ) </small>
                                            Publish your course 
                                            </span>
                                                </h4><br />
                                                <Button   type='submit' variant="primary rounded-pill bg-gradient-primary btn-lg lessonAsk "
                                                onClick={goToCourse}> 
                                                  Preview Course  
                                                </Button>

                                                {data?.isPublish ? (
                                                <Button disabled   type='submit' variant="success rounded-pill bg-gradient-success btn-lg lessonAsk2 "
                                                > 
                                                    Course is Published
                                                </Button>
                                                ) : (
                                                <Button   type='submit' variant="warning rounded-pill bg-gradient-warning btn-lg lessonAsk2 "
                                                onClick={pusblishHandle}>
                                                    Publish Course
                                                </Button>
                                                )} &nbsp; &nbsp; &nbsp;

                                                
                                            </div>
                                        </div><br /><br /><br /><br /><br /><br /><br /><br /><br />
                                    </div>

                                    <div className="">                                                                                
                                        {lessonsBySection?.map((sec, sectionIndexx) => (
                                            <div key={sectionIndexx}>
                                            {sec.map((lesson, lessonIndex) => (
                                                <>      
                                                    {lessonIndex === 0 && (                                                    
                                                        <p className='courseSection2 '>
                                                            Section {sectionIndexx}: {lesson.section}
                                                        </p>
                                                    )}   
                                                    <div className='row'>                                   
                                                    <div key={lesson._id} className="offset-xl-2 col-xl-8">
                                                        <label for="exampleInputEmaill" className='teachCoursTitle'>                            
                                                        <span className='LessonTittle42'>Lesson {lesson?.lessonNumber}: {lesson?.title}</span>
                                                        </label><br />
                                                        {/* <video controls className="card-img-top">      
                                                            <source 
                                                                src={`https://ask2l.s3.us-east-2.amazonaws.com/public/lessons/${lesson?.mediaId}`}
                                                                type="video/mp4"
                                                            />
                                                        </video>  */}
                                                        <img className="imgTop31" src='../../../assets/img/playvideo.png' />
                                                        <div className="form-group text-center">
                                                             <h6 className="lessonOrder1" placeholder="  Plan Name" type="text">Lesson Order:</h6>                                                              
                                                             <Button   type='submit' variant="primary rounded-pill bg-gradient-primary   "
                                                                onClick={() => deleteHandler(lesson)}> 
                                                                    delete
                                                            </Button>
                                                             {lessonIndex != 0 &&
                                                            <Button   type='submit' variant="success rounded-pill bg-gradient-success   "
                                                                onClick={() => moveLessonUp(lesson, sec[lessonIndex-1])}> 
                                                            Move Lesson Up
                                                            </Button>
                                                            }
                                                            { lessonIndex != sec.length - 1 &&
                                                            <Button   type='submit' variant="success rounded-pill bg-gradient-success   "
                                                                onClick={() => moveLessonDown(lesson, sec[lessonIndex+1])}> 
                                                            Move Lesson Down
                                                            </Button>
                                                            }
                                                        </div>                                                        
                                                        <br /><br /><br />
                                                    </div> 
                                                    </div>
                                                </>
                                            ))}                  
                                            </div> 
                                        ))}                  
                                    </div>
                                    </>
                                )} 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default TeacherNewLessons
